import { render } from "./agree-msg-box.vue?vue&type=template&id=33a8160e&scoped=true&ts=true"
import script from "./agree-msg-box.vue?vue&type=script&lang=ts"
export * from "./agree-msg-box.vue?vue&type=script&lang=ts"

import "./agree-msg-box.vue?vue&type=style&index=0&id=33a8160e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a8160e"]])

export default __exports__